import { render, staticRenderFns } from "./PlanejarOrdemServico.vue?vue&type=template&id=34059c56"
import script from "./PlanejarOrdemServico.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlanejarOrdemServico.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports